export default __webpack_public_path__ + "static/media/ruler.ea8d9050.svg";